import type { CSSProperties, ComponentType, ReactNode } from 'react';

import { RiLinkM } from '@remixicon/react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

export const DEFAULT_ARTIFACT_ICON = { Icon: RiLinkM, color: '#2ECC71' };

export interface ArtifactExtensionOptions
  extends ItemRenderExtensionOptions<AttachmentFragment> {
  icon?: (item: AttachmentFragment) => {
    Icon: ComponentType<{
      size?: number | string;
      className?: string;
      style?: CSSProperties;
    }>;
    color: string;
  };
  label?: string;
  category?: string;
  renderHeaderActions?: (item: AttachmentFragment) => ReactNode;
  renderCard?: (
    item: AttachmentFragment,
    options: {
      onNavigate: () => void;
      onDelete?: () => void;
      onRename?: () => void;
    },
  ) => ReactNode;
  getNavigationPath?: (item: AttachmentFragment) => string | undefined;
  renderListItem?: (
    item: AttachmentFragment,
    options: {
      onSelect: () => void;
      onNavigateToResource?: () => void;
      onDelete?: () => void;
      onRename?: () => void;
      onHide?: () => void;
      icon: ReactNode;
    },
  ) => ReactNode;
}

export const ArtifactExtensions =
  createItemRenderExtensions<ArtifactExtensionOptions>({
    id: 'artifact',
  });

export const createArtifactExtension = (options: ArtifactExtensionOptions) => {
  return createItemRenderExtension<ArtifactExtensionOptions>(options);
};

export const useArtifactExtensions = () => {
  return useItemRenderExtensions<ArtifactExtensionOptions>(ArtifactExtensions);
};

export const resolveArtifactIcon = (
  ext: ArtifactExtensionOptions | undefined,
  artifact: AttachmentFragment,
) => ext?.icon?.(artifact) ?? DEFAULT_ARTIFACT_ICON;
